import { Paper, Flex, Stack, useMantineTheme, Checkbox } from '@mantine/core';
import TableFileName from './TableFileName';
import TableStatusText from './TableStatusText';
import TableLoadingRow from './TableLoadingRow';
import TableListMessages from './TableListMessages';
import { TableFilesRow } from '../interfaces/TableFilesRow';
import classes from './TableFolders.module.css';

interface FileFolderCardProps {
  row: TableFilesRow;
  selected: boolean;
  disabled: boolean;
  toggleSelect: (checked: boolean) => void;
}

export default function FileFolderCard({ row, selected, disabled, toggleSelect }: FileFolderCardProps) {
  const theme = useMantineTheme();
  return (
    <Paper withBorder radius="md" p="sm" className={[
        classes.mobileCard,
        row.loading?.completed ? classes.cardOk : row.loading?.error ? classes.cardError : row.loading?.loading ? classes.cardLoading : '',
      ].join(' ')}>
      <Flex justify="space-between" align="center" mb="xs">
        <Flex align="center" gap="sm">
          <Checkbox
            checked={selected}
            disabled={disabled}
            onChange={(e) => toggleSelect(e.currentTarget.checked)}
            size="sm"
            radius="sm"
            classNames={{ input: classes.selectionCheckboxInput, icon: classes.selectionCheckboxIcon, inner: classes.selectionCheckboxInner }}
          />
          <TableFileName text={row.name} />
        </Flex>
        <Flex align="center" gap="sm">
          {row.loading && <TableLoadingRow loadingState={row.loading} />}
          <TableStatusText status={row.status} />
        </Flex>
      </Flex>
      {row.messages && row.messages.length > 0 && (
        <Stack gap="xs">
          <TableListMessages messages={row.messages} />
        </Stack>
      )}
    </Paper>
  );
}
